
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import {formMixin, formOptionsMixin, formValidationMixin} from "../mixins";
import {debounce} from "lodash";

@Component({
  inheritAttrs: false
})
export default class Select extends Mixins(formMixin, formOptionsMixin, formValidationMixin) {
  @Ref() readonly validator!: any;

  @Prop({default: false})
  appendToBody: boolean;

  @Prop({default: 600})
  debounceTime: number;

  @Prop()
  options: any;

  @Prop({default: false})
  isInactiveIncludeFacilities: boolean;

  @Prop({default: false})
  required: boolean;

  created() {
    this.debouncedSearch = debounce(
      (search, loading) => this.$emit("search", search, loading),
      this.debounceTime
    );
  }

  debouncedSearch(search, loading) {
  }

  blur() {
    if (this.rules) {
      this.validator.validate();
    }
  }

  onSearch(search, loading) {
    if (search === null || search === "") return;
    this.debouncedSearch(search, loading);
  }
}
